import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class Sidebar extends Component{
  constructor() {
    super();
    this.state = {
      signOut: false,
    }

    this.signOut = this.signOut.bind(this)
    this.toggleSignOut = this.toggleSignOut.bind(this)
  }

  toggleSignOut() {
    this.setState(prevState => ({signOut: !prevState.signOut}))
  }

  signOut() {
    localStorage.removeItem("admin-token");
    this.props.toggleAuthenticate()
    this.props.history.push('/backoffice/login')
  }

  renderSignOut() {
    return(
      <div className="SignOut-overlay">
        <div className="SignOut">
          <p>Are you sure you want to sign out?</p>
          <button onClick={this.signOut}>Yes</button>
          <button onClick={this.toggleSignOut} className="outline">
            Cancel
          </button>
        </div>
      </div>
    )
  }

  render() {
    const location = this.props.location.pathname
    return(
      <div className="Sidebar">
        <p className="Sidebar-logo">ESCAPAT</p>
        <ul>
          <li>
            {
              location === '/backoffice/months'
              ?
              <Link className="active" to='/backoffice/months'>Months</Link>
              :
              <Link to='/backoffice/months'>Months</Link>
            }
          </li>
          <li>
            {
              location === '/backoffice/products'
              ?
              <Link className="active" to='/backoffice/products'>Products</Link>
              :
              <Link to='/backoffice/products'>Products</Link>
            }
          </li>
          <li>
            {
              location === '/backoffice/deliveries'
              ?
              <Link className="active" to='/backoffice/deliveries'>Deliveries</Link>
              :
              <Link to='/backoffice/deliveries'>Deliveries</Link>
            }
          </li>
          <li>
            {
              location === '/backoffice/customers'
              ?
              <Link className="active" to='/backoffice/customers'>Customers</Link>
              :
              <Link to='/backoffice/customers'>Customers</Link>
            }
          </li>
        </ul>
        <button className="Sidebar-signout" onClick={this.toggleSignOut}>
          Sign Out
        </button>
        {
          this.state.signOut
          ?
          this.renderSignOut()
          :
          null
        }
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Sidebar.jsx